module.exports = __webpack_public_path__ + "static/media/RLC_logo.4e05bcde.png";